import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// Translation provided by Vuetify (javascript)
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#0f8ee2',
                secondary: '#8bc34a',
                accent: '#cddc39',
                error: '#f44336',
                warning: '#ffc107',
                info: '#607d8b',
                success: '#4caf50',
            },
            dark: {
              primary: '#0f8ee2',
              secondary: '#8bc34a',
              accent: '#cddc39',
              error: '#f44336',
              warning: '#ffc107',
              info: '#607d8b',
              success: '#4caf50',
            },
        },
    },
    lang: {
        locales: { es },
        current: 'es',
    },
});
